import { RootState } from '..'

const getAppState = (state: RootState) => state.appSlice

export { getAppState }
